import { atom } from "recoil"

export const migrationContactsConcatRequestIdState = atom({
  key: "atoms/contact/migrationContactsConcatRequestIdState",
  default: 0,
})
